import { cx } from '@linaria/core';
import { useId } from 'react';
import { resets } from '@ui/css';
import { Checkmark } from './checkmark.js';
import { getOptionValue, getOptionLabel } from './option.listbox.js';
import { wrapper, input, content } from './option.style.js';
import { Radio } from './radio.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Option({
  baseId,
  value,
  selectedValues,
  type,
  onChange
}) {
  const id = useId();
  const selected = !!selectedValues?.some(selected => getOptionValue(selected) === getOptionValue(value));
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    children: [/*#__PURE__*/jsx("input", {
      className: cx(input, resets.screenReaderOnlyCls),
      type: type,
      id: id,
      name: baseId,
      checked: selected,
      value: getOptionValue(value),
      onChange: onChange
    }), /*#__PURE__*/jsxs("label", {
      htmlFor: id,
      className: content,
      children: [type === "checkbox" ? /*#__PURE__*/jsx(Checkmark, {
        toggled: selected
      }) : /*#__PURE__*/jsx(Radio, {
        toggled: selected
      }), getOptionLabel(value)]
    })]
  });
}

export { Option };
//# sourceMappingURL=option.toggle-group.js.map
